import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import { PAGES, CONSULTATION_TYPES } from '../../constants/constants';
import { gaPageview } from '../../utils/dev';
import { Dialog, DialogContent } from '@material-ui/core';

export default class PricingPage extends Component {
  constructor(props) {
    super(props);
    this.state = { subscriptionInfo: false };
    this.subscriptionDetail = null;
  }
  componentDidMount() {
    const page = PAGES['pricing'];
    document.title = page.title;

    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    gaPageview(this.props.location);
  }

  render() {
    const { subscriptionInfo } = this.state;
    const mapPricing = CONSULTATION_TYPES.map((consult, index) => {
      if (consult.type === 'subscription') {
        this.subscriptionDetail = consult;
      }

      return (
        <Fragment key={`consult-${index}`}>
          <div
            className={`col-sm-4 ${
              subscriptionInfo && consult.type !== 'subscription'
                ? 'hidden'
                : ''
            }`}
          >
            <div className='consult-type text-center'>
              <div
                className='consult-header'
                style={{ backgroundColor: consult.background }}
              >
                <h3>{consult.title}</h3>
                <div
                  className='consult-price'
                  style={{ backgroundColor: 'rgba(0,0,0,0.08)' }}
                >
                  <span className='amount'>${consult.price}</span>
                  <span>
                    {consult.type === 'subscription'
                      ? 'Ongoing care'
                      : 'per consult'}
                  </span>
                </div>
              </div>
              <div className='consult-message'>
                {consult.message.map((message, index) => (
                  <p key={consult.type + '-message-' + index}>{message}</p>
                ))}
              </div>
              <div className='consult-purchase'>
                {consult.type === 'subscription' ? (
                  <button
                    className='btn btn-vetchat'
                    onClick={() => {
                      this.setState({
                        subscriptionInfo: !subscriptionInfo
                      });
                    }}
                  >
                    More Details
                  </button>
                ) : (
                  <Link to={`/${consult.link}`} className='btn btn-vetchat'>
                    {consult.type}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </Fragment>
      );
    });

    return (
      <Fragment>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 section-title'>
              <h2>Chat with a vet now</h2>
            </div>
            <div className='col-sm-12 pricing-tables'>
              <div className='row'>{mapPricing}</div>
            </div>
            <div className='clearfix'></div>
            <div className='col-sm-12'>
              <p>All consultaitons include:</p>
            </div>
            <div className='col-sm-6 pricing-list'>
              <ul className=''>
                <li>Experienced Aussie vets, via video, phone or text</li>
                <li>
                  Get help within minutes, 6am – midnight Sydney, Australia time
                </li>
              </ul>
            </div>
            <div className='col-sm-6 pricing-list'>
              <ul className=''>
                <li>Next day follow up</li>
                <li>100% PEACE OF MIND GUARANTEE</li>
              </ul>
            </div>
            <div className='clear'></div>
            <div className='col-sm-4'>
              <div className='vetchat-service text-center'>
                <span className='badge badge-info'>
                  <i className='fa fa-user-md' />
                </span>
                <h4>Personalised advice from expert vets</h4>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='vetchat-service text-center'>
                <span className='badge badge-info'>
                  <i className='fa fa-plus-square' />
                </span>
                <h4>Peace of mind for any concern with your pet</h4>
              </div>
            </div>
            <div className='col-sm-4'>
              <div className='vetchat-service text-center'>
                <span className='badge badge-info'>
                  <i className='fa fa-mobile' />
                </span>
                <h4>First destination for advice</h4>
              </div>
            </div>
          </div>
        </div>

        {/* SUbscription Details DIalog */}
        <Dialog
          open={subscriptionInfo}
          maxWidth='md'
          onBackdropClick={() => {
            this.setState({ subscriptionInfo: false });
          }}
        >
          <DialogContent>
            <div className='row subscription-dialog'>
              <div className='col-md-8'>
                {this.subscriptionDetail.extraInfo}
              </div>
              <div className='col-sm-4 hidden-sm hidden-xs'>
                <div className='consult-type text-center'>
                  <div
                    className='consult-header'
                    style={{
                      backgroundColor: this.subscriptionDetail.background
                    }}
                  >
                    <h3>{this.subscriptionDetail.title}</h3>
                    <div
                      className='consult-price'
                      style={{ backgroundColor: 'rgba(0,0,0,0.08)' }}
                    >
                      <span className='amount'>
                        ${this.subscriptionDetail.price}
                      </span>
                      <span>Ongoing care</span>
                    </div>
                  </div>
                  <div className='consult-message'>
                    {this.subscriptionDetail.message.map((message, index) => (
                      <p key={'subscription-dialog-message-' + index}>
                        {message}
                      </p>
                    ))}
                  </div>
                  <div className='consult-purchase'>
                    <button
                      type='button'
                      className='btn btn-vetchat'
                      onClick={() => {
                        this.setState({
                          subscriptionInfo: false
                        });
                      }}
                    >
                      Less Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}
